// This File is use to Initialise multiple Context Hooks for application.
import {createContext} from "react";

const ViewMangementContext = createContext(); // it is used to Set and check Current Page View.
const RecordsManagementContext = createContext(); // it is used to Set and check Records for the page.
export { ViewMangementContext, RecordsManagementContext };